<template>
    <div
        v-if="showNav"
        class="navigationWrapper tran"
        :class="[currentActive,fixedHeight]"
        @touchmove="onTouchMove"
    >
        <div class="navigation-content">
            <router-link
                to="/"
                class="J_ping column shopping-column"
                :clstag="'jr|keycount|8530052_index_bottom|index'"
                report-eventid="MInterestFree_BottomNavHome"
                report-eventparam="1"
            >
                <p>
                    <img
                        :src="shoppingIcon"
                        alt
                        class="shopping-icon"
                    >
                </p>
                <p class="text">商城</p>
            </router-link>
            <div
                to="/DiscoverPage"
                class="J_ping column discover-column"
                :clstag="'jr|keycount|8530052_index_bottom|discover01'"
                report-eventid="MInterestFree_BottomNavFind"
                report-eventparam="1"
                @click="toJddx"
            >
                <p>
                    <img
                        :src="discoverIcon"
                        alt
                        class="shopping-icon"
                    >
                </p>
                <p class="text">种草</p>
            </div>
            <router-link
                v-if="hasCategory"
                to="/category"
                class="J_ping column category-column"
                :clstag="'jr|keycount|8530052_index_bottom|classify'"
                report-eventid="MInterestFree_BottomNavCategory"
                report-eventparam="1"
            >
                <p>
                    <img
                        :src="categoryIcon"
                        alt
                        class="shopping-icon"
                    >
                </p>
                <p class="text">分类</p>
            </router-link>
            <div
                class="J_ping column cart-column"
                @click="toMessage"
                :clstag="'jr|keycount|8530052_index_bottom|msg'"
                report-eventid="MInterestFree_BottomNavCart"
                report-eventparam="1"
                style="position:relative"
            >
                <p>
                    <img
                        :src="messageImg"
                        alt
                        class="shopping-icon"
                    >
                </p>
                <p class="text">消息</p>
                <p
                    class="shopping-thumb"
                    v-if="messageNumber && messageNumber!=0"
                ><span>{{messageNumber}}</span></p>
            </div>
            <div
                @click="onToMePage"
                class="J_ping column me-column"
                :clstag="'jr|keycount|8530052_index_bottom|my'"
                report-eventid="MInterestFree_BottomNavMy"
                report-eventparam="1"
            >
                <p>
                    <img
                        :src="meIcon"
                        alt
                        class="shopping-icon"
                    >
                </p>
                <p class="text">我的</p>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
import KPL from '@/buscomponents/KPL.vue';
import { getStaticConfig } from '@/util/common';
import { getJSONPData } from '@/util/sqRequestService';
import { forceLogin } from '@/util/login';
import './../scss/mixin.scss';
let hasCategoryTab = false;
try {
    hasCategoryTab = getStaticConfig('hasCategoryTab');
} catch (error) {
    console.log(error);
}

export default {
    name: 'BUSNavigation',
    components: {
        KPL
    },
    props: {
        isShow: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            currentActive: 'shopping-active',
            shoppingIcon: '//m.360buyimg.com/jrqb/jfs/t26554/343/892525118/1087/42eda29c/5bbc60deNf134a2e0.png',
            discoverIcon: '//m.360buyimg.com/jrqb/jfs/t27310/286/915329334/1905/49cb37e7/5bbc60deN3cf26364.png',
            categoryIcon: '//img12.360buyimg.com/jrpmobile/jfs/t26422/354/2234836706/799/8d16111a/5bfb4f64Neb54fce7.png',
            // cartIcon: '//m.360buyimg.com/jrqb/jfs/t27754/270/902207991/1009/e67c8cd7/5bbc60deNd0c45cef.png',
            messageImg: 'https://img12.360buyimg.com/jrpmobile/jfs/t1/76318/27/3604/1829/5d1c612eEf164fc32/acb6471f063f70ae.jpg',
            meIcon: '//m.360buyimg.com/jrqb/jfs/t25141/27/1775073315/1223/7c9348ab/5bbc60deNe6bad65f.png',
            link: 'https://p.m.jd.com/cart/cart.action',
            showNav: false,
            fixedHeight: '',
            hasCategory: hasCategoryTab,
            messageNumber: '0'
        };
    },
    mounted() {
        let delay = 10;
        setTimeout(() => {
            this._initInstance();
        }, delay);
        // if (this.messageNumber) {
        //     const _messageNumber = JSON.stringify(this.messageNumber);
        //     if (_messageNumber.length >= 3) {
        //         this.messageNumber = '99+';
        //     }
        // }
        this.getMessageCount();
    },
    destroyed() {
        this.$refs.kplIns = null;
        this.$refs = null;
        this._self = null;
    },
    methods: {
        toJddx() {
            var arg = '';
            if (location.search != '') {
                try {
                    var searchs = location.search.substring(1, location.search.length).split('&');
                    for (var i = 0; i < searchs.length; i++) {
                        if (searchs[i].indexOf('channel') != -1) {
                            arg = searchs[i];
                            break;
                        }
                    }
                } catch (e) {}
            }
            if (arg != '') {
                arg = '&' + arg;
            }
            location.href = 'https://jddx.jd.com/m/jdd/index.html?from=mxxq' + arg;
        },
        _initInstance() {
            const hash = this.$router.history.current.name;
            this.showNav = this.isShow;
            switch (hash) {
                case 'shoppingcart':
                    this.currentActive = 'shoppingcart-active';
                    break;
                case 'me':
                    // this.meIcon = '//img12.360buyimg.com/jrpmobile/jfs/t25648/207/1283866757/1308/bc44d2c4/5b91014dNf6583e0a.png';
                    this.meIcon = '//m.360buyimg.com/jrqb/jfs/t1/5410/1/9498/896/5bacaf6cEca50ed39/a322e638788619b8.png';
                    this.currentActive = 'me-active';
                    break;
                case 'category':
                    this.categoryIcon = '//img12.360buyimg.com/jrpmobile/jfs/t1/6513/22/6449/721/5bdff32fE65ca71dc/f4484a11bc96fe4c.png';
                    this.currentActive = 'category-active';
                    break;
                case 'DiscoverPage':
                    // this.discoverIcon = './images/discover_active.png';
                    // this.currentActive = 'discover-active';
                    // if ($.device && $.device.weixin) {
                    //   this.showNav = false;
                    // }
                    break;
                default:
                    // this.shoppingIcon = '//img12.360buyimg.com/jrpmobile/jfs/t26077/278/1307571349/1314/332595be/5b91014dN148b4352.png';
                    this.shoppingIcon = '//m.360buyimg.com/jrqb/jfs/t1/5524/34/9369/752/5bacad50Ee453f223/e7e802b0eb85b1e4.png';
                    this.currentActive = 'shopping-active';
                    break;
            }
        },
        show() {
            this.showNav = true;
        },
        hide() {
            this.showNav = false;
        },
        onTouchMove(e) {
            e.preventDefault();
        },
        onToMePage() {
            if ($.device && $.device.jdjr) {
                this.$router.push({ path: '/me' });
            } else {
                const url = window.location.origin + window.location.pathname + '#/me';
                forceLogin(url);
            }
        },
        //消息中心
        toMessage() {
            window.location.href = 'https://jddx.jd.com/m/message/home.html';
        },
        //消息总数
        getMessageCount() {
            const param = {
                callback: 'messageList'
            };
            getJSONPData('//sq.jr.jd.com/message/count', param).then(res => {
                if (res.success) {
                    if (res.value && res.value != 0) {
                        const _messageNumber = JSON.stringify(res.value);
                        if (_messageNumber.length >= 3) {
                            this.messageNumber = '99+';
                        } else {
                            this.messageNumber = res.value;
                        }
                    } else {
                        this.messageNumber = 0;
                    }
                } else {
                    this.messageNumber = 0;
                }
            });
        }
    }
};
</script>

<style lang="scss">
@import '@/scss/mixin.scss';

.navigationWrapper {
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    width: 100%;
    height: $rem100;
    box-sizing: content-box;
    background: #ffffff;
    box-shadow: 0 -3px 6px 0 rgba(38, 50, 71, 0.03);
    padding-bottom: constant(safe-area-inset-bottom) !important;
    padding-bottom: env(safe-area-inset-bottom) !important;

    .navigation-content {
        width: 100%;
        height: $rem100;
        overflow: hidden;
        flex-direction: row;
        display: flex;
        flex: 1;
    }
}

.column {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;
    text-align: center;
    .shopping-icon,
    .shopping-cart,
    .shopping-me,
    .discover-active {
        width: $rem46;
        height: $rem46;
    }

    .text {
        margin-top: $rem5;
        font-size: $rem20;
        color: #999999;
        text-align: center;
    }
}

.shopping-active {
    .shopping-column {
        .text {
            color: #333333;
        }
    }
}

.me-active {
    .me-column {
        .text {
            color: #333333;
        }
    }
}

.shoppingcart-active {
    .shoppingcart-column {
        .text {
            color: #333333;
        }
    }
}

.discover-active {
    .discover-column {
        .text {
            color: #333333;
        }
    }
}

.category-active {
    .category-column {
        .text {
            color: #333333;
        }
    }
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
    transition: all 0.6s ease;
}

.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateY(100%);
    opacity: 0;
}
.shopping-thumb {
    position: absolute;
    left: $rem90;
    top: $rem8;
    background: #eb422f;
    font-size: $rem20;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    border-radius: $rem18;
    // display: block;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: $rem30;
    min-height: $rem30;
    text-align: center;
    padding: 0 $rem8;
}
</style>
